import { render, staticRenderFns } from "./AppShapesToolbar.vue?vue&type=template&id=5ab446a8&"
import script from "./AppShapesToolbar.vue?vue&type=script&lang=js&"
export * from "./AppShapesToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports